import { useEffect } from 'react';
import { Alert, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import BottomNavigationBar from '../../components/BottomNavigationBar';
import TaskCard from '../../components/TaskCard';
import UserPageHeader from '../../components/UserPageHeader';
import useTasksStore from '../../store/tasks';

export default function TasksPage() {
  const { tasks, isLoading, error, fetchTasks } = useTasksStore();
  const { t } = useTranslation();

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  return (
    <Container className="pt-3 pb-5">
      <Row>
        <Col xs={12}>
          <UserPageHeader />

          {isLoading && (
            <div className="text-center py-5">
              <Spinner animation="border" variant="light" role="status">
                <span className="visually-hidden">{t('common.loading')}</span>
              </Spinner>
            </div>
          )}

          {error && (
            <Alert variant="danger" role="alert">
              {error}
            </Alert>
          )}

          {!isLoading && !error && (
            <>
              {tasks.today.length > 0 && (
                <div className="mb-4">
                  <h2 className="h4 text-white mb-3">{t('tasks.today')}</h2>
                  {tasks.today.map(task => (
                    <TaskCard
                      key={task._id}
                      icon={task.icon}
                      taskId={task._id}
                    />
                  ))}
                </div>
              )}

              {tasks.thisWeek.length > 0 && (
                <div className="mb-4">
                  <h2 className="h4 text-white mb-3">{t('tasks.thisWeek')}</h2>
                  {tasks.thisWeek.map(task => (
                    <TaskCard
                      key={task._id}
                      icon={task.icon}
                      taskId={task._id}
                    />
                  ))}
                </div>
              )}

              {tasks.today.length === 0 && tasks.thisWeek.length === 0 && (
                <div className="text-center py-5">
                  <p className="text-white-50">{t('tasks.noActiveTasks')}</p>
                </div>
              )}
            </>
          )}
        </Col>
      </Row>
      <BottomNavigationBar />
    </Container>
  );
}
